import { useQuery } from '@tanstack/react-query';
import { axiosGet } from '../../api/axios-handler';

export interface DefaultSettingsResponse {
  accept_policy_description: string;
  benefits_description: string;
  benefits_description_2: string;
  landing_page_logo_file_path: string;
  landing_page_message: string;
  learn_more_redirect_url: string;
  theme: JSON;
  welcome_video_vimeo_id: string;
  defaultLandingPageLogo: string;
  defaultLandingPageMessage: string;
  defaultBenefitsDescriptionMessage: string;
  defaultBenefitsDescriptionMessage1: string;
  defaultWelcomeVideoId: string;
}

const getDefaultSettings = (): Promise<DefaultSettingsResponse> => {
  return axiosGet(`/settings/default`, {}).then((res) => res.data);
};

export const useDefaultSettings = () => {
  const { data, isLoading, isFetching, error, refetch } = useQuery<DefaultSettingsResponse>(
    ['settings', 'system', 'defaults'],
    () => {
      return getDefaultSettings();
    },
    {
      select: (data) => {
        return {
          ...data,
          defaultLandingPageLogo: data?.['landing_page_logo_file_path'],
          defaultLandingPageMessage: data?.['landing_page_message'],
          defaultBenefitsDescriptionMessage: data?.['benefits_description'],
          defaultBenefitsDescriptionMessage1: data?.['benefits_description_2'],
          defaultWelcomeVideoId: data?.['welcome_video_vimeo_id'],
        };
      },
    },
  );

  return { data, isLoading, isFetching, error, refetch };
};
